/* eslint-disable react/prop-types */
import React from "react";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import { CardComp } from "../cardComp";

export const tableCustomStyles = {
  table: {
    style: {
      width: "100%",
    },
  },
  headRow: {
    style: {
      backgroundColor: "var(--color-primary-dark)",
      minHeight: "52px",
    },
  },
  headCells: {
    style: {
      fontSize: "14px",
      fontWeight: 600,
      color: "#fff",
      paddingLeft: "10px",
      paddingRight: "10px",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      paddingLeft: "10px",
      paddingRight: "10px",
    },
  },
  rows: {
    style: {
      minHeight: "52px",
    },
  },
};

const Style = styled.div`
  .rdt_Table {
    border-radius: 10px;
    overflow: visible;
    width: 100%;
  }

  /* Responsive wrapper from react-data-table clips overflow-y when
     overflow-x is auto — keep x scroll but allow action menus to paint. */
  > .card,
  .card-body,
  [class*="TableWrapper"],
  .rdt_TableWrapper {
    overflow: visible !important;
  }

  .rdt_TableBody {
    overflow: visible !important;
  }

  .rdt_TableRow {
    overflow: visible !important;
  }

  .rdt_TableCell {
    overflow: visible !important;
    position: relative;
  }

  .rdt_TableHeadRow {
    font-size: 14px !important;
    color: #fff;
    font-weight: 600;
    background: var(--color-primary-dark);
    border-start-end-radius: 10px;
    border-start-start-radius: 10px;
  }

  .rdt_TableBody {
    margin-bottom: ${(props) =>
      props?.MarginBottom ? props?.MarginBottom : `20rem`};
  }

  .rdt_TableRow:last-child .rdt_TableCell:first-child {
    border-end-start-radius: 10px;
  }

  .rdt_TableRow:last-child .rdt_TableCell:last-child {
    border-end-end-radius: 10px;
  }

  .rdt_TableCell {
    border: 1px solid #e0e0e0;
    padding: ${(props) => (props?.cellPadding ? props.cellPadding : "10px")};
    font-size: 14px !important;
  }
`;

export const TableCompData = ({
  title,
  data,
  pagination,
  columns,
  selectableRows,
  onSelectedRowsChange,
  clearSelectedRows,
  contextActions,
  progressPending = false,
  progressComponent,
  message,
  noDataComponent,
  marginBottom,
  cellPadding,
  conditionalRowStyles,
  /** Pass false/null to keep the given row order (avoids "month 10" before "month 2"). */
  defaultSortFieldId = 1,
}) => {
  const customStyles = {
    ...tableCustomStyles,
    cells: {
      style: {
        ...tableCustomStyles.cells.style,
        paddingTop: cellPadding || "10px",
        paddingBottom: cellPadding || "10px",
      },
    },
  };

  const emptyContent = noDataComponent ?? message ?? undefined;
  const sortFieldId =
    defaultSortFieldId === false || defaultSortFieldId === null
      ? undefined
      : defaultSortFieldId;

  return (
    <Style cellPadding={cellPadding} MarginBottom={marginBottom}>
      <CardComp cardBodyClassName={"py-0 px-0"} cardClassName={"pt-4 px-0"}>
        <DataTable
          responsive={true}
          title={title}
          columns={columns}
          data={data ? data : []}
          {...(sortFieldId !== undefined ? { defaultSortFieldId: sortFieldId } : {})}
          customStyles={customStyles}
          pagination={pagination ? true : false}
          selectableRows={selectableRows ? true : false}
          onSelectedRowsChange={onSelectedRowsChange}
          clearSelectedRows={clearSelectedRows}
          contextActions={contextActions}
          progressPending={progressPending}
          progressComponent={progressComponent}
          persistTableHead={true}
          noDataComponent={emptyContent}
          conditionalRowStyles={conditionalRowStyles}
        />
      </CardComp>
    </Style>
  );
};

export { default as TablePagination } from "./Pagination";

export const PlainTable = ({
  title,
  data,
  pagination,
  columns,
  selectableRows,
  progressPending = false,
  message,
  noDataComponent,
  marginBottom,
  cellPadding,
}) => {
  const customStyles = {
    ...tableCustomStyles,
    cells: {
      style: {
        ...tableCustomStyles.cells.style,
        paddingTop: cellPadding || "10px",
        paddingBottom: cellPadding || "10px",
      },
    },
  };

  const emptyContent = noDataComponent ?? message ?? undefined;

  return (
    <Style cellPadding={cellPadding} MarginBottom={marginBottom}>
      <DataTable
        responsive={true}
        title={title}
        columns={columns}
        data={data ? data : []}
        defaultSortFieldId={1}
        customStyles={customStyles}
        pagination={pagination ? true : false}
        selectableRows={selectableRows ? true : false}
        progressPending={progressPending}
        persistTableHead={true}
        noDataComponent={emptyContent}
      />
    </Style>
  );
};
